// Important!!! If you use domTemplate replace this file, This file can remove.
import React, { PureComponent } from 'react';
import DomTemplate from './domTemplate';
import shortid from 'shortid';

interface IDivContainerTemplateProps {
    source: any;
}

class DivContainerTemplate extends PureComponent<IDivContainerTemplateProps, any> {
    constructor(props: IDivContainerTemplateProps) {
        super(props);
    }

    public render() {
        const { source } = this.props;

        return (
            <DomTemplate sourceM={source} dataStringM={'divContainer'} classNameM={''} key={shortid.generate()} />
        );
    }
}

export default DivContainerTemplate;
